import { WidgetState } from 'components/organisms/projects-report/widgets';
import { numberSorter } from 'utils/sorters';
import { UsersReportRecord } from '../../types';
import { WidgetStateError } from './use-widget-data';

export const getTopNBilliableUtlization = (
  records: UsersReportRecord[],
  numberOfRecords = 3,
): WidgetState<UsersReportRecord[], WidgetStateError> => {
  const recordsWithCompletedTimeCount = records.filter((record) =>
    Boolean(record.timeEntryInfo.billableUtilization),
  );

  if (recordsWithCompletedTimeCount.length === 0) {
    return WidgetState.noData();
  }
  const topRecords = recordsWithCompletedTimeCount
    .sort(
      (
        { timeEntryInfo: { billableUtilization: a } }: UsersReportRecord,
        { timeEntryInfo: { billableUtilization: b } }: UsersReportRecord,
      ) => numberSorter(a, b) * -1,
    )
    .slice(0, numberOfRecords);

  return WidgetState.data(topRecords);
};
